import React from 'react';
import { DayPicker } from 'react-day-picker';
import moment from 'moment';
import './index.scss';
import './custom-components.scss';

const customFormatters = {
  formatWeekdayName: (day) => {
    const customWeekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return customWeekdays[day.getDay()];
  },
};

// Helper function to count days and get week info
const getRangeInfo = (range) => {
  if (!range?.from || !range?.to) return null;

  const startDate = moment(range.from);
  const endDate = moment(range.to);

  // Count days (inclusive)
  const daysCount = endDate.diff(startDate, 'days') + 1;

  const rangeInfo = `${startDate.get('date')}-${endDate.get('date')}`;

  const weekInfo = `weeks of ${startDate.isoWeek()}`;

  return {
    daysCount,
    rangeInfo,
    weekInfo,
  };
};

export const DatePicker = (props) => {
  const rangeInfo = getRangeInfo(props.selectedRange);

  return (
    <DayPicker
      {...props}
      components={{
        CaptionLabel: ({ children }) => (
          <div className="caption-label">
            <div className="caption-label__title">{children}</div>
            <div className="caption-label__subtitle">
              {rangeInfo && (
                <div className="caption-label__subtitle-range">
                  <div className="caption-label__subtitle-range-info">{rangeInfo.rangeInfo}</div>
                  <div className="caption-label__subtitle-range-week">{rangeInfo.weekInfo}</div>
                </div>
              )}
            </div>
          </div>
        ),
      }}
      formatters={customFormatters}
      showOutsideDays
      mode="range"
    />
  );
};
